import { IPageInfo } from '../common.interface';

export interface Wallet {
  id: string,
  userId: string,
  bankName: string,
  branchName: string,
  branchCode: string,
  accountType: string,
  accountNumber: string,
  accountHolderName?: string,
  createdAt: string,
  updatedAt: string
}

export interface IDrivers {
  countryCode: number,
  createdAt: string,
  dob: string,
  email: string
  fullName: string,
  gender: string
  id: string
  isBlocked: boolean,
  isOnline: boolean,
  isPhoneVerified: boolean,
  isVerified: boolean,
  isOnride: boolean,
  phone: string,
  roleId: string,
  wallet: Wallet,
  verificationToken: string,
  onboardingStatus?: string,
  onboardingStep?: number,
  driverInfo?: DriverInfo,
}

export interface IDriverListResponse {
  data: {
    users: IDrivers[];
    pageInfo: IPageInfo;
  };
  message: string;
  status: boolean;
  statusCode: boolean;
}

/** Response shape for GET /driver/available — handles both array and paginated { users, pageInfo } */
export interface IAvailableDriversResponse {
  data?: IDrivers[] | {
    users: IDrivers[];
    pageInfo?: IPageInfo;
  };
  users?: IDrivers[];
  pageInfo?: IPageInfo;
  message?: string;
  status?: boolean;
  statusCode?: number;
}

export interface DriverDetailResponse {
  message: string;
  statusCode: number;
  status: boolean;
  data: DriverData;
}

export interface DriverData {
  id: string;
  roleId: string;
  fullName: string;
  email: string;
  countryCode: string;
  phone: string;
  verificationToken: string | null;
  dob: string | null;
  gender: string | null;
  isPhoneVerified: boolean;
  isOnline: boolean;
  isBlocked: boolean;
  isVerified: boolean;
  onboardingStatus?: string;
  onboardingStep?: number;
  createdAt: string;

  wallet: Wallet;
  addresses: Address[];
  driverInfo: DriverInfo;
  media: Media[];
  driverZones?: any[];
}

export interface Wallet {
  id: string;
  userId: string;
  bankName: string;
  branchName: string;
  branchCode: string;
  accountType: string;
  accountNumber: string;
  accountHolderName?: string;
  balance: string;
  createdAt: string;
  updatedAt: string;
}

export interface Address {
  id: string;
  userId: string;
  addressType: string;
  label: string | null;
  fullName: string | null;
  phoneNumber: string | null;
  houseNumber: string | null;
  streetNumber: string | null;
  streetName: string | null;
  suburb: string | null;
  city: string | null;
  province: string | null;
  postalCode: string | null;
  country: string | null;
  companyName: string | null;
  department: string | null;
  unit: string | null;
  buildingName: string | null;
  addressLine: string | null;
  landmark: string | null;
  deliveryInstructions: string | null;
  latitude: number | null;
  longitude: number | null;
  createdAt: string;
  updatedAt: string;
}

export enum DriverStatus {
  AVAILABLE = 'AVAILABLE',
  ON_RIDE = 'ON_RIDE',
  ON_DELIVERY = 'ON_DELIVERY',
}

export interface DriverInfo {
  id: string;
  userId: string;
  vehicleType: string;
  vehicleNumber: string;
  vehicleColor: string;
  isAvailable: boolean;
  driverStatus?: DriverStatus;
  activeOrderCount?: number;
  createdAt: string;
  updatedAt: string;
}

type MediaReferenceType =
  | "vehicle_image"
  | "residence_proof"
  | "driving_license"
  | "south_africa_id"
  | "traceable_reference"
  | "profile_picture";

interface Media {
  id: string;
  url: string;
  referenceType: MediaReferenceType;
  referenceId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateDriverForm {
  fullName?: string;
  email?: string;
  countryCode?: string;
  phone?: string;
  password?: string;
  vehicleType?: string;
  vehicleNumber?: string;
  // label?: string;
  // addressFullName?: string;
  // phoneNumber?: string;
  // houseNumber?: string;
  // streetNumber?: string;
  // streetName?: string;
  // suburb?: string;
  // city?: string;
  // province?: string;
  // postalCode?: string;
  // country?: string;
  // companyName?: string;
  // department?: string;
  // unit?: string;
  // buildingName?: string;
  // landmark?: string;
  // deliveryInstructions?: string;
  addressType?: string;
  addressLine?: string;
  latitude?: string | number;
  longitude?: string | number;
  bankName?: string;
  branchName?: string;
  branchCode?: string;
  accountType?: string;
  accountNumber?: string;
  accountHolderName?: string;
  drivingLicense?: (File | string)[];
  southAfricaId?: (File | string)[];
  vehicleImage?: (File | string)[];
  profilePhoto?: (File | string)[];
  zones?: string[];
}
